export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[700px] mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-medium mb-5 whitespace-nowrap">
            <i className="ri-mail-send-line"></i>
            联系我们
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            联系我们 / 投稿通道
          </h2>
          <p className="text-sm text-foreground-500 leading-relaxed mb-8 max-w-[500px] mx-auto">
            欢迎广大吃瓜群众提供线索和爆料，优质投稿将获得首页推荐位展示机会。
            同时也欢迎品牌合作、广告投放等商务洽谈。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 flex-wrap">
            <a
              href="#"
              className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors cursor-pointer text-sm"
            >
              <i className="ri-edit-2-line"></i>
              在线投稿
            </a>
            <a
              href="#"
              className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 border-2 border-primary-200 text-primary-700 font-medium rounded-full hover:bg-primary-50 transition-colors cursor-pointer text-sm"
            >
              <i className="ri-shake-hands-line"></i>
              商务合作
            </a>
            <div className="flex items-center gap-2 px-6 py-3 text-sm text-foreground-600">
              <i className="ri-mail-line text-primary-500"></i>
              <span>contact@51chigua.com</span>
            </div>
          </div>

          <div className="flex items-center justify-center gap-4 mt-6 text-foreground-400">
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer">
              <i className="ri-tiktok-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}